/* eslint-disable @typescript-eslint/no-unused-vars */
import { useMemo } from "react"

import { Obj } from "scrivito"
import { ProjectPageObjAttributes } from "scrivito/Objs/ProjectPage/ProjectPageObjClass"
import { SharedProjectPageObjAttributes } from "scrivito/Objs/SharedProjectPage/SharedProjectPageObjClass"

interface UseProjectPageAdditionalActionsArgs {
  projectID: string
  page: Obj<ProjectPageObjAttributes | SharedProjectPageObjAttributes>
}

export function useProjectPageAdditionalActions({
  projectID,
  page
}: UseProjectPageAdditionalActionsArgs) {
  // const buttonProps = useProjectChatButton({ page })

  // const chatAction: Action = useMemo(
  //   () => ({
  //     ...buttonProps,
  //     id: `${projectID}__chat`,
  //     key: "project__actions__chat",
  //     "data-testid": "project__actions__activate",
  //     icon: IconName.COMMENT
  //   }),
  //   [projectID, buttonProps]
  // )

  // 7267 -- Comment this back in in case the project chat should be re-enabled
  // const additionalActions = useMemo(() => [chatAction], [chatAction])

  const additionalActions = useMemo(() => [], [])
  return additionalActions
}
